/** @jsxImportSource @emotion/react */
import APIClient from 'APIClient';
import { css } from '@emotion/react';
import { useEffect, useState } from 'react';

import Text from 'components/Text';
import { MEDIA_QUERIES } from 'styles/constants';
import { WHITE, PURPLE_MEDIUM } from 'styles/colors';
import CampaignSmallCard from 'components/cards/CampaignSmallCard';
import LandingBussinessHeroBg from 'assets/images/LandingBussinessHeroBg.png';
import GirlsTakingSelfieOverPinkBg from 'assets/images/GirlsTakingSelfieOverPinkBg.webp';
import GirlsTakingSelfieOverPinkBgPNG from 'assets/images/GirlsTakingSelfieOverPinkBg.png';

const styles = css`
  overflow-x: hidden;
  background-image: url(${GirlsTakingSelfieOverPinkBgPNG});
  background-image: url(${GirlsTakingSelfieOverPinkBg});
  background-size: cover;
  background-position: 70% 50%;
  background-repeat: no-repeat;
  padding-left: 20px;
  height: 100vh;
  min-height: 800px;
  display: flex;
  flex-direction: column;

  .header-content {
    padding: 0px 10px 0px 100px;
    display: flex;
    justify-content: end;
    flex-direction: column;
    padding-top: 170px;
    height: 100vh;
    min-height: 800px;
  }

  .header-title {
    color: ${PURPLE_MEDIUM};
    leading-trim: both;
    text-edge: cap;
    font-style: normal;
    font-weight: 600;
    line-height: 120%; /* 64.8px */
    margin-bottom: 20px;
  }
  .header-subtitle {
    padding: 14px 40px 14px 40px;
    align-items: center;
    border-radius: 50px;
    border: 1px solid var(--ui-20-light-purple, #efeeff);
    background: rgba(212, 203, 226, 0.2);
    color: var(--ui-20-light-purple, #efeeff);
    font-family: Roobert;
    font-style: normal;
    font-weight: 600;
    line-height: 120%; /* 57.6px */
    text-alogn: center;
    margin-bottom: 45px;
    max-width: 32rem;
  }
  .header-text {
    color: #efeeff;
    leading-trim: both;
    text-edge: cap;
    font-family: Roobert;
    font-size: 28px;
    font-style: normal;
    line-height: 145%;
    margin-bottom: 75px;
    margin-top: 45px;
  }
  .header-text span {
    color: #c5bcfe;
    leading-trim: both;
    text-edge: cap;
    font-family: Roobert;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 145%;
  }

  .header-campaigns-feed {
    display: flex;
    flex-direction: column;
    max-height: 100vh;
    min-height: 800px;
    overflow-y: scroll;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
    margin-right: -100px;
    margin-left: 100px;
    align-self: flex-start;
  }

  .header-campaigns-feed::-webkit-scrollbar {
    display: none;
  }

  ${MEDIA_QUERIES.mobile} {
    background-image: url(${LandingBussinessHeroBg});
    padding-left: 0;
    height: auto;
    min-height: 650px;

    .header-content {
      padding: 0px 16px;
      display: flex;
      justify-content: center;
      flex-direction: column;
      height: auto;
      min-height: 450px;
    }

    .header-title {
      font-size: 34px;
      text-align: center;
      margin-bottom: 10px;
      padding-top: 75px;
    }

    .header-subtitle {
      font-size: 28px;
      text-align: center;
      max-width: 100%;
    }

    .header-text {
      color: #efeeff;
      leading-trim: both;
      text-edge: cap;
      font-family: Roobert;
      font-size: 16px;
      font-style: normal;
      line-height: 145%;
      margin-bottom: 15px;
      margin-top: 10px;
      text-align: center;
    }

    .header-text span {
      font-size: 12px;
      font-style: normal;
    }

    .header-campaigns-feed {
      display: flex;
      flex-direction: row;
      max-height: 50vh;
      min-height: 80px;
      overflow-x: scroll;
      overflow-y: hidden;
      -ms-overflow-style: none;
      scrollbar-width: none;
      margin: 0;
      align-self: flex-start;
      width: 100%;
    }
  }
`;

export const FeekHeader = () => {
  const [campaignsFeedHeader, setCampaignsFeedHeader] = useState([]);

  useEffect(() => {
    APIClient.getCampaignsLandingHeader()
      .then(({ data }) => {
        setCampaignsFeedHeader(data.docs);
      })
      .catch((error) => {
        console.error('Error fetching campaigns:', error);
      });
  }, []);

  return (
    <section
      css={styles}
      aria-labelledby="hero-heading"
      role="banner"
    >
      {/* SEO heading - positioned off-screen to avoid layout shift */}
      <h1
        id="hero-heading"
        style={{
          position: 'absolute',
          left: '-9999px',
          width: '1px',
          height: '1px',
          overflow: 'hidden',
          clip: 'rect(0, 0, 0, 0)',
        }}
        aria-hidden="true"
      >
        Feek - Colabora con marcas, disfruta beneficios y gana
        recompensas
      </h1>
      <div className="mb80">
        <div className="row">
          <div className="col-12 col-lg-5 col-xl-6 header-content">
            <Text
              color={WHITE}
              fontSize={54}
              className="header-title"
            >
              Obtén descuentos y <br /> beneficios exclusivos
            </Text>
            <Text
              color={WHITE}
              fontSize={40}
              className="header-subtitle"
            >
              a cambio de una story
            </Text>
            <Text color={WHITE} fontSize={12} className="header-text">
              Descubre, reserva y comparte con Feek. <b>Feek</b>.{' '}
              <br />
              <span>
                ¡Vive esa vida de influencer que siempre quisiste!
              </span>
            </Text>
          </div>
          <div className="col-lg-7 col-xl-6 header-campaigns-feed d-lg-flex">
            {campaignsFeedHeader.map((campaign, index) => (
              <CampaignSmallCard
                style={{
                  ...(index === 0 ? { marginTop: 60 } : {}),
                }}
                key={campaign._id + index || index}
                color={campaign.color}
                type={campaign.type}
                title={campaign.title}
                image={campaign.image}
                location={campaign?.customer?.city}
                feekspot={campaign?.customer?.name}
                feekpoints={campaign?.task.feek_points}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
